// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1nkyv","left":"StickyBox_left__29HhF","right":"StickyBox_right__XhYi_"};